/**
 * Face group enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Face group asset role labels
export const faceGroupAssetRoleLabels = {
    before: 'Before',
    after: 'After',
    untagged: 'Untagged',
};
export const faceGroupAssetRoleValues = Object.keys(faceGroupAssetRoleLabels);
//# sourceMappingURL=face-groups.js.map